import { Component, OnInit, Injector, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { GlobalsService, MyErrorStateMatcher } from '../../shared/shared';
import { User } from "../../schemas/schemas";
import { AuthComponent } from '../auth.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'nepraunik-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit {
  private loginModel: User;
  public authService: AuthService;
  public loginForm: FormGroup;
  public matcher = new MyErrorStateMatcher();
  public hide = false;
  
  constructor(public route: ActivatedRoute, injector: Injector, private router: Router, private globalsService: GlobalsService, private authComponent: AuthComponent, private fb: FormBuilder) {
    // This will solve circular dependency injection problem
    setTimeout(() => this.authService = injector.get(AuthService));
    this.loginModel = new User();
    authComponent.AuthSubject = "Anmeldung";
  }

  public Login() {
    if (this.loginModel.Username != "" && this.loginModel.Password != "") {
      this.authService.login(this.loginModel).subscribe(
        (response: any) => {
          if (response === true) {
            this.router.navigateByUrl("/vertrag");
          }
        }, (error: any) => {
          console.log(error);
        }, () => {
        });
    }
  }

  public HitEnter(loginform: any, $event: KeyboardEvent) {
    if ($event != null) {
      if ($event.keyCode == 13) {
        console.log("Enter hit");
        this.Login();
      }
    }
  }

  logout() {
    event.preventDefault();

    if (this.authService.logout()) {
      this.router.navigate(['']);
    }
    else {
      console.log("Error on logout");
    }
  }

  ngOnInit() {
    // Use the formbuilder to build the Form model
    this.loginForm = this.fb.group({
      Name: ['', [Validators.required]],
      Password: ['', [Validators.required]],
    });
  }

  get name() { return this.loginForm.get('Name'); }
  get password() { return this.loginForm.get('Password'); }

  public onFormSubmit() {
    if (this.loginForm.valid) {
      this.loginModel = this.loginForm.value;
      this.Login();
      console.log(this.loginModel);
    }
  }

  public onNavigate(route) {
    this.router.navigate([route]);
  }
}



// WEBPACK FOOTER //
// ./src/app/_authentication/login/login.component.ts